module.exports = __webpack_public_path__ + "static/14-cf5e59ad2938da42e89dbfac3755b8a1.jpg";